












import { Component, Prop, Vue } from 'vue-property-decorator';
import { AmountBox } from '@tencent/wphk-ui';
import { countDecimalPlaces, getCurrencyCodeByType, getValidCurrencyType, parseCurrencyAria, accMul } from '../utils';
import { UtilsTypes } from '@tencent/wphk-act-base-types';

@Component({
  components: {
    AmountBox,
  },
})
export default class Amount extends Vue {
  /** 币种类型 */
  @Prop({ default: UtilsTypes.CurrencyType.HKD }) public currencyType!: UtilsTypes.CurrencyType;
  /** 金额，单位元 */
  @Prop({ default: 0 }) public prizeAmountYuan!: number;
  /** 金额字体大小，视觉稿件提供的金额font-size */
  @Prop({ default: 56 }) public size!: number;
  /** 缩放比例 */
  @Prop({ default: 0.78 }) public zoomRatio!: number;
  /** 是否根据数值进行缩放 */
  @Prop({ default: true }) public isZoom!: boolean;

  parseCurrencyAria = parseCurrencyAria;

  /** 币种类型，默认为CurrencyType.HKD */
  get formattedCurrencyType() {
    return getValidCurrencyType(this.currencyType);
  }

  /** 币种 */
  get formattedCurrencyCode() {
    return getCurrencyCodeByType(this.currencyType);
  }

  /** 小数点 */
  get formattedBit() {
    return countDecimalPlaces(this.prizeAmountYuan) || 0;
  }

  get prizeAmountFen() {
    return accMul(this.prizeAmountYuan || 0, 100);
  }

  /** 根据金额格式化后的金额大小 */
  get formattedSize() {
    // 如果不进行缩放
    if (!this.isZoom) return this.size;

    // 如果进行缩放
    const amountString = this.prizeAmountYuan.toString();
    const len = amountString.length;
    if (len < 3) {
      return this.size;
    }
    return this.size * this.zoomRatio;
  }
}
